export const STATIC_ASSETS_CACHE_KEY = 'assets';
